import React from "react";
import PageHeaderActions from "../../../../sing/components/PageHeaderActions/PageHeaderActions";

export function ManageCouplesHeaderActions({
  isAdmin,
  onViewAll,
  onCreate,
  onFilterChange,
}: {
  isAdmin: boolean;
  onViewAll: () => void;
  onCreate: () => void;
  onFilterChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}) {
  return (
    <PageHeaderActions>
      <div className="sing-page-actions">
        <button
          type="button"
          className="sing-page-action-link"
          onClick={onViewAll}
        >
          View All Couples
        </button>
        <button
          type="button"
          className="sing-page-action-link"
          onClick={onCreate}
        >
          Create Couple
        </button>
        {isAdmin && (
          <a href="/priest-list" className="sing-page-action-link">
            Spiritual Director (Priest/Deacon) List
          </a>
        )}
        <div className="sing-page-action-select">
          <select
            className="form-control minimal"
            onChange={onFilterChange}
            aria-label="Couple list filter"
          >
            <option value="0">All Couples</option>
            <option value="1">Missing Data</option>
          </select>
        </div>
      </div>
    </PageHeaderActions>
  );
}
